import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col q-pr-md" }
const _hoisted_3 = { class: "col q-pl-md" }

import { is, useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxFilterIssues from "src/components/filter/SfxFilterIssues.vue"
import SfxFilterCorrectiveWork from "src/components/filter/SfxFilterCorrectiveWork.vue"
import SfxFilterRegularWork from "src/components/filter/SfxFilterRegularWork.vue"
import SfxFilterWorkOrders from "src/components/filter/SfxFilterWorkOrders.vue"
import SfxSeparator from "src/components/special/SfxSeparator.vue"
import SfxToggleSettings from "src/components/toggle/SfxToggleSettings.vue"
import router from "src/router"
import {
  CorrectiveWorkFilter,
  IssuesFilter,
  RegularWorkFilter,
  SystemLink,
  useFilterStore,
  WorkOrderFilter,
} from "src/stores/filterStore"
import {
  CORRECTIVE_WORK_FILTERS_DEFAULT,
  ISSUE_FILTERS_DEFAULT,
  REGULAR_WORK_FILTERS_DEFAULT,
  WORK_ORDER_FILTERS_DEFAULT,
} from "src/util/constants/filters"
import { QR_CODE, RFID } from "src/util/enums/filters"
import { NamedManagerPath } from "src/util/enums/namedPaths"
import { getISOTimeString } from "src/util/functions/time"
import { showErrorNotification } from "src/util/functions/notifications"
import { getWorkDomainWorkspaceListData } from "src/util/functions/entityData"
import { WorkDomainWorkspace } from "src/util/types/dataModels/workDomain"
import SfxFilterSystemLink from "src/components/filter/SfxFilterSystemLink.vue"
import { onBeforeMount, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogFilterItems',
  props: {
  entityForWorkOrderPage: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const filterStore = useFilterStore()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const workDomainOptions = ref<WorkDomainWorkspace[]>([])

const systemLink = ref<SystemLink>()
const hasRfid = ref()
const hasQrCode = ref()
const issueFilters = ref<IssuesFilter>()
const regularWorkFilters = ref<RegularWorkFilter>()
const correctiveWorkFilters = ref<CorrectiveWorkFilter>()
const workOrderFilters = ref<WorkOrderFilter>()

//endregion

//region Lifecycle

onBeforeMount(async () => {
  const workDomains = await getWorkDomainWorkspaceListData()
  workDomainOptions.value = workDomains.map((workDomain) => workDomain.toMutableJSON())

  setFiltersFromStore()
})

//endregion

//region Functions

function setFiltersFromStore() {
  systemLink.value = filterStore.itemsPageFilters.systemLink
  hasRfid.value = filterStore.itemsPageFilters.hasRfid
  hasQrCode.value = filterStore.itemsPageFilters.hasQrCode
  issueFilters.value = { ...filterStore.itemsPageFilters.issuesFilter }
  regularWorkFilters.value = { ...filterStore.itemsPageFilters.regularWorkFilter }
  correctiveWorkFilters.value = { ...filterStore.itemsPageFilters.correctiveWorkFilter }
  workOrderFilters.value = { ...filterStore.itemsPageFilters.workOrderFilter }
}

function handleSystemLinkClose() {
  systemLink.value = undefined
  filterStore.itemsPageFilters.systemLink = undefined
}

function saveFilters() {
  // Just to be sure
  if (issueFilters.value?.isRangeTemporal) {
    const startTime = getISOTimeString(
      issueFilters.value?.raisedRange?.startDate,
      issueFilters.value?.raisedRange?.startTime
    )
    const endTime = getISOTimeString(
      issueFilters.value?.raisedRange?.endDate,
      issueFilters.value?.raisedRange?.endTime
    )

    if (startTime && endTime && startTime >= endTime) {
      return showErrorNotification(t("sfxErrorMsg.error_range_end_after_range_start"))
    }
  }

  filterStore.itemsPageFilters.hasFilters = true
  filterStore.itemsPageFilters.hasIssueFilters = !is.deepEqual(
    issueFilters.value,
    ISSUE_FILTERS_DEFAULT
  )
  filterStore.itemsPageFilters.hasRegularWorkFilters = !is.deepEqual(
    regularWorkFilters.value,
    REGULAR_WORK_FILTERS_DEFAULT
  )
  filterStore.itemsPageFilters.hasCorrectiveWorkFilters = !is.deepEqual(
    correctiveWorkFilters.value,
    CORRECTIVE_WORK_FILTERS_DEFAULT
  )
  filterStore.itemsPageFilters.hasWorkOrderFilters = !is.deepEqual(
    workOrderFilters.value,
    WORK_ORDER_FILTERS_DEFAULT
  )

  filterStore.itemsPageFilters.hasRfid = hasRfid.value
  filterStore.itemsPageFilters.hasQrCode = hasQrCode.value
  filterStore.itemsPageFilters.issuesFilter = issueFilters.value || ISSUE_FILTERS_DEFAULT
  filterStore.itemsPageFilters.regularWorkFilter =
    regularWorkFilters.value || REGULAR_WORK_FILTERS_DEFAULT
  filterStore.itemsPageFilters.correctiveWorkFilter =
    correctiveWorkFilters.value || CORRECTIVE_WORK_FILTERS_DEFAULT
  filterStore.itemsPageFilters.workOrderFilter =
    workOrderFilters.value || WORK_ORDER_FILTERS_DEFAULT

  onDialogOK()

  if (!props.entityForWorkOrderPage) {
    router.replace({
      name: NamedManagerPath.SELECT_ITEM,
      query: {
        filters: JSON.stringify(filterStore.itemsPageFilters),
      },
    })
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-filter"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-pb-sm" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.title_filter_items")), 1)
            ]),
            _: 1
          }),
          (systemLink.value)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(SfxFilterSystemLink, {
                    "system-link": systemLink.value,
                    onRemove: _cache[0] || (_cache[0] = ($event: any) => (handleSystemLinkClose()))
                  }, null, 8, ["system-link"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              (!props.entityForWorkOrderPage)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.identifiers")), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(SfxToggleSettings, {
                          class: "q-py-none",
                          html: "",
                          trinary: "",
                          modelValue: hasRfid.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((hasRfid).value = $event)),
                          description: _unref(t)('sfxDialogFilter.has_rfid'),
                          "true-value": _unref(RFID).YES,
                          "true-label": _unref(t)('sfxDialogFilter.yes'),
                          "false-value": _unref(RFID).NO,
                          "false-label": _unref(t)('sfxDialogFilter.no'),
                          "indeterminate-value": _unref(RFID).EITHER,
                          "indeterminate-label": _unref(t)('sfxDialogFilter.either')
                        }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"])
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(SfxToggleSettings, {
                          class: "q-py-none",
                          html: "",
                          trinary: "",
                          modelValue: hasQrCode.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((hasQrCode).value = $event)),
                          description: _unref(t)('sfxDialogFilter.has_qr_code'),
                          "true-value": _unref(QR_CODE).YES,
                          "true-label": _unref(t)('sfxDialogFilter.yes'),
                          "false-value": _unref(QR_CODE).NO,
                          "false-label": _unref(t)('sfxDialogFilter.no'),
                          "indeterminate-value": _unref(QR_CODE).EITHER,
                          "indeterminate-label": _unref(t)('sfxDialogFilter.either')
                        }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"])
                      ])
                    ]),
                    _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.related_entities")), 1)
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (issueFilters.value)
                ? (_openBlock(), _createBlock(SfxFilterIssues, {
                    key: 1,
                    "issue-filters": issueFilters.value,
                    "onUpdate:issueFilters": _cache[3] || (_cache[3] = ($event: any) => ((issueFilters).value = $event)),
                    "work-domain-options": workDomainOptions.value
                  }, null, 8, ["issue-filters", "work-domain-options"]))
                : _createCommentVNode("", true),
              _createVNode(SfxSeparator, { dimmed: "" }),
              (regularWorkFilters.value)
                ? (_openBlock(), _createBlock(SfxFilterRegularWork, {
                    key: 2,
                    "regular-work-filters": regularWorkFilters.value,
                    "onUpdate:regularWorkFilters": _cache[4] || (_cache[4] = ($event: any) => ((regularWorkFilters).value = $event)),
                    "work-domain-options": workDomainOptions.value
                  }, null, 8, ["regular-work-filters", "work-domain-options"]))
                : _createCommentVNode("", true),
              _createVNode(SfxSeparator, { dimmed: "" }),
              (correctiveWorkFilters.value)
                ? (_openBlock(), _createBlock(SfxFilterCorrectiveWork, {
                    key: 3,
                    "corrective-work-filters": correctiveWorkFilters.value,
                    "onUpdate:correctiveWorkFilters": _cache[5] || (_cache[5] = ($event: any) => ((correctiveWorkFilters).value = $event)),
                    "work-domain-options": workDomainOptions.value
                  }, null, 8, ["corrective-work-filters", "work-domain-options"]))
                : _createCommentVNode("", true),
              (!props.entityForWorkOrderPage)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createVNode(SfxSeparator, { dimmed: "" }),
                    (workOrderFilters.value)
                      ? (_openBlock(), _createBlock(SfxFilterWorkOrders, {
                          key: 0,
                          "work-order-filters": workOrderFilters.value,
                          "onUpdate:workOrderFilters": _cache[6] || (_cache[6] = ($event: any) => ((workOrderFilters).value = $event)),
                          "work-domain-options": workDomainOptions.value
                        }, null, 8, ["work-order-filters", "work-domain-options"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "row justify-center q-pa-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                class: "col-4 q-mr-sm",
                onClick: _unref(onDialogCancel),
                label: _unref(t)('sfxButtons.btn_close')
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                class: "col-4",
                onClick: saveFilters,
                label: _unref(t)('sfxButtons.btn_apply_changes')
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})